import { fetchHandoff } from '@innspel/core/handoff';
import { useCallback } from 'react';
import { HandoffSurface } from '../../lib/index.ts';
import type { PortalKonfig } from '../konfig.ts';

/**
 * 4 — TV-overlevering, nådd via QR-lenke `/h/<id>` (S1.3). Flaten er pakkens (`HandoffSurface`),
 * den samme som `mount(el, { handoffId })` i `@innspel/web` — én kodebase, to utganger. Portalen
 * gir den tre ting: henting med kjernens `fetchHandoff`, «Logg inn hos …» som redirect til
 * leietakeren, og linjene innsenderen fjernet tatt vare på over den redirecten (`sessionStorage`,
 * som tokenet — aldri `localStorage`). Tilbake fra innloggingen henter flaten økten på nytt; det
 * tillater kontrakten før innsendingen.
 */
export function TvOverlevering({
  id,
  konfig,
  onLoggInn,
  fjernede,
  fetch: hent,
}: {
  id: string;
  konfig: PortalKonfig;
  /** Får linjene som er fjernet, så de overlever redirecten. */
  onLoggInn: (fjernede: string[]) => void;
  /** Linjene som var fjernet før innloggingen. */
  fjernede?: string[];
  fetch?: typeof fetch;
}) {
  const last = useCallback(
    () => fetchHandoff({ baseUrl: konfig.baseUrl, tenantKey: konfig.tenantKey, handoffId: id, ...(hent ? { fetch: hent } : {}) }),
    [konfig.baseUrl, konfig.tenantKey, id, hent],
  );
  return (
    <HandoffSurface
      handoffId={id}
      load={last}
      tenantName={konfig.tenantName}
      {...(konfig.loginRedirectUrl ? { onLogIn: onLoggInn } : {})}
      {...(fjernede?.length ? { initialRemoved: fjernede } : {})}
    />
  );
}
